export default __webpack_public_path__ + "static/media/1069.a6a7eaa9.png";